import React, { Component, useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import auth, { getCurrentUser } from "../../Services/authService";
import publicIp from "react-public-ip"
import { formatTotalHours, getFieldData, getMonthLastDay, getTotalHours } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUserDetails, getLogoUpdatedStatus, getUserProfileLogo, loadUserDetails } from "../../app/store/auth";
import {
  getGenerateBulkInvoiceStatus, getPartnerCandidatesReport, loadPartnerAllCandidateRpt,
  partnerCandidateGenerateBulkInv, partnerCandidatesInvGenerated
} from "../../app/store/partner";
import { generatedInvoiePdfReceived, getGeneratedInvPdf, printGeneratedInvoice } from "../../app/store/timeLogInvoice";
import { getAlert } from "../../Services/appAlerts";

const GenerateInvoice = (props) => {
  const { invoiceNumber, notes, genShowHide, handleGenShowHide, candidateObj,
    selectedObj, wfTask, timeLogInvoices, invNumber, logoPicObj, logoData, allRates, entType } = props;
  const [ipAddress, setIpAddress] = useState("");
  const [ddName, setDdName] = useState("");
  const [rate, setRate] = useState(0);
  const [partnerId, setPartnerId] = useState(0);
  const [esignName, setEsignName] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [candidateList, setCandidateList] = useState([]);
  const [pdfBtnProccess, setPdfBtnProccess] = useState(false);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [generateCount, setGenerateCount] = useState(0);
  //const [logoPicObj, setLogoPicObj] = useState(null);

  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const partnerCandidatesReportSelector = useSelector(getPartnerCandidatesReport);
  const generatedInvPdfSelector = useSelector(getGeneratedInvPdf);
  const generateBulkInvoiceStatusSelector = useSelector(getGenerateBulkInvoiceStatus);
  //const userProfilePicSelector = useSelector(getUserProfileLogo);

  const usrType = localStorage.getItem("userType");

  const printBodyRef = useRef(null);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    const loadIpAddress = async () => {
      const ipv4 = await publicIp.v4() || "";
      setIpAddress(ipv4);

    }
    loadIpAddress();
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (!userDetailsSelector)
      dispatch(loadUserDetails(usrId));

  }, []);

  useEffect(() => {
    if (!genShowHide) {
      setEsignName("");
    }
  }, [genShowHide])

  // useEffect(() => {
  //   if (userProfilePicSelector) {
  //     setLogoPicObj(userProfilePicSelector);
  //   }
  // }, [userProfilePicSelector])

  useEffect(() => {
    setUserDetails(userDetailsSelector);
  }, [userDetailsSelector]);


  useEffect(() => {
    if (candidateObj) {
      let ddName = "subcontractorenrollmentform";
      let rate = 0;
      let partnerId = 0;
      if (usrType === "recruiter") {
        ddName = "recruiterenrollmentform";
        if (candidateObj.rates?.recruiterRate > 0)
          rate = candidateObj.rates?.recruiterRate

        if (parseInt(candidateObj.activeloans) > 0)
          partnerId = candidateObj.activeloans;

      } else {

        if (candidateObj.rates?.subcontractorRate > 0)
          rate = candidateObj.rates?.subcontractorRate;

        if (parseInt(candidateObj.loanamountlimit) > 0)
          partnerId = candidateObj.loanamountlimit;
      }
      setPartnerId(partnerId);
      setDdName(ddName);
    }
  }, [candidateObj]);

  const getApplicableRateDetails = (item) => {
    const itemYear = parseInt(item?.year, 10);
    const itemMonth = parseInt(item?.month, 10);
    const rateField = usrType === "recruiter" ? "recruiterRate" : "subcontractorRate";
    const dateField = usrType === "recruiter" ? "recruiterEffectiveDate" : "subcontractorEffectiveDate";

    let rate = 0;
    if (candidateObj.rates?.recruiterRate > 0 && usrType === "recruiter")
      rate = candidateObj.rates?.recruiterRate

    if (candidateObj.rates?.subcontractorRate > 0 && usrType !== "recruiter")
      rate = candidateObj.rates?.subcontractorRate;

    console.log(rate);

    const matchedRate = Array.isArray(allRates)
      ? allRates
        .filter((rate) => {
          if (!itemYear || !itemMonth) return false;
          const effDt = new Date(rate?.[dateField]);
          if (Number.isNaN(effDt.getTime())) return false;

          const effYear = effDt.getFullYear();
          const effMonth = effDt.getMonth() + 1;

          return (
            effYear < itemYear ||
            (effYear === itemYear && effMonth <= itemMonth)
          );
        })
        .sort(
          (a, b) =>
            new Date(b?.[dateField]).getTime() -
            new Date(a?.[dateField]).getTime()
        )[0]
      : null;

    const fallbackRate = parseFloat(rate || 0);
    const rateValue =
      matchedRate?.[rateField] !== null &&
        matchedRate?.[rateField] !== undefined &&
        matchedRate?.[rateField] !== ""
        ? parseFloat(matchedRate[rateField])
        : fallbackRate;

    const effectiveDate = matchedRate?.[dateField] || rate;

    return {
      rate: rateValue,
      effectiveDate,
    };
  };

  useEffect(() => {
    if (selectedObj && candidateObj) {
      let partId = 0;
      if (usrType === "recruiter") {
        if (parseInt(candidateObj.activeloans) > 0)
          partId = candidateObj.activeloans;
      } else {
        if (parseInt(candidateObj.loanamountlimit) > 0)
          partId = candidateObj.loanamountlimit;
      }
      dispatch(loadPartnerAllCandidateRpt(selectedObj.year, selectedObj.month, partId, usrType, selectedObj.candidateId));

      const { rate: applicableRate } = getApplicableRateDetails(selectedObj);
      setRate(applicableRate);
    }
  }, [selectedObj, candidateObj]);

  useEffect(() => {
    setCandidateList(partnerCandidatesReportSelector);
  }, [partnerCandidatesReportSelector])

  const doSubmit = () => {
    handlePrintPdf();
  };

  const handleSaveGenerate = async () => {
    setSaveBtnProccess(true);

    let htmlBody = printBodyRef.current.innerHTML;

    if (logoPicObj?.imagePreviewUrl) {
      const imgElement = "<img src='" + logoPicObj.imagePreviewUrl + "' style='height:90px; width:auto; border-radius:10px; margin-bottom:5px;'>";
      if (imgElement) {
        htmlBody =
          "<div style='text-align:left;padding-bottom:10px'>" +
          imgElement + "</img>" +
          "</div>" +
          printBodyRef.current.innerHTML;
      }
    }
    else if (logoData) {
      const updImgElement = await getEmergencyFoundImg(
        process.env.REACT_APP_API_BASEURL + "/CompanyLogo/" + logoData
      );

      if (updImgElement) {
        htmlBody =
          "<div style='text-align:left;padding-bottom:10px'>" +
          updImgElement.outerHTML + "</img>" +
          "</div>" +
          printBodyRef.current.innerHTML;
      }
    }
    console.log(candidateList)
    candidateList.map(async (item, key) => {
      const cObj = { ...item };
      if (invoiceNumber)
        cObj.invoiceNumber = invoiceNumber;

      const frmData = new FormData();
      frmData.append("html", htmlBody);
      frmData.append("candidate", JSON.stringify(cObj));
      frmData.append("sign", "");
      frmData.append("remarks", "Invoice");
      frmData.append("userId", currentUser.id);
      frmData.append("workflowTask", JSON.stringify(wfTask));

      dispatch(partnerCandidateGenerateBulkInv(frmData));
      setGenerateCount(key + 1);
    });

  };

  useEffect(() => {
    if (generateBulkInvoiceStatusSelector && generateCount === candidateList.length) {
      setSaveBtnProccess(false);
      getAlert("", "Generated and Sent Successfully", "success");
      setGenerateCount(0);
      dispatch(partnerCandidatesInvGenerated(false));
      setCandidateList([]);
      handleGenShowHide("save");
    }
  }, [generateBulkInvoiceStatusSelector])

  const handlePrintPdf = async () => {
    try {
      setPdfBtnProccess(true);

      let htmlBody = printBodyRef.current.innerHTML;
      // wait for getEmergencyFoundImg to resolve
      if (logoPicObj?.imagePreviewUrl) {
        const imgElement = "<img src='" + logoPicObj.imagePreviewUrl + "' style='height:90px; width:auto; border-radius:10px; margin-bottom:5px;'>";
        if (imgElement) {
          htmlBody =
            "<div style='text-align:left;padding-bottom:10px'>" +
            imgElement + "</img>" +
            "</div>" +
            printBodyRef.current.innerHTML;
        }
      }
      else if (logoData) {
        const updImgElement = await getEmergencyFoundImg(
          process.env.REACT_APP_API_BASEURL + "/CompanyLogo/" + logoData
        );

        if (updImgElement) {
          htmlBody =
            "<div style='text-align:left;padding-bottom:10px'>" +
            updImgElement.outerHTML + "</img>" +
            "</div>" +
            printBodyRef.current.innerHTML;
        }
      }

      const frmData = new FormData();
      frmData.append("html", htmlBody);
      dispatch(printGeneratedInvoice(frmData));
    } catch (err) {
      console.error("Error creating image:", err);
      setPdfBtnProccess(false);
    }
    // finally {
    //   setPdfBtnProccess(false);
    // }
  };

  const getEmergencyFoundImg = (url) => {
    return new Promise((resolve) => {
      const img = new Image();

      // Set CORS before src
      img.crossOrigin = "anonymous";
      img.src = url;

      img.onload = () => {
        const c = document.createElement("canvas");
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;

        const ctx = c.getContext("2d");
        ctx.drawImage(img, 0, 0);

        try {
          const base64String = c.toDataURL("image/png");

          const img2 = document.createElement("img");
          img2.src = base64String;
          img2.style.height = "90px";
          img2.style.width = "auto";
          img2.style.borderRadius = "10px";
          img2.style.marginBottom = "5px";

          resolve(img2);
        } catch (e) {
          // In case of toDataURL failure, return empty string
          resolve('');
        }
      };

      // Instead of rejecting, resolve with empty string on error
      img.onerror = () => {
        resolve('');
      };
    });
  };


  useEffect(() => {
    if (generatedInvPdfSelector?.size > 0) {
      const url = window.URL.createObjectURL(generatedInvPdfSelector);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      dispatch(generatedInvoiePdfReceived(null))
      setPdfBtnProccess(false);
    }
  }, [generatedInvPdfSelector])

  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";

    let wt;
    try {
      wt = JSON.parse(obj.workingHrs);
    } catch (e) {
      return "";
    }

    if (!Array.isArray(wt) || wt.length === 0) return "";

    const sortWt = [...wt].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const first = sortWt[0];
    const last = sortWt[sortWt.length - 1];

    const lastDate =
      last.type === "m"
        ? getMonthLastDay(last.start)
        : last.start;

    return (
      <p>
        {new Date(first.start).toLocaleDateString()} -{" "}
        {new Date(lastDate).toLocaleDateString()}
      </p>
    );
  };

  const getAdjustmentAmout = (item) => {
    const invItem = timeLogInvoices.find(x => x.timeLogId === item.id);

    if (!invItem) {
      return <span>0.00</span>;
    }

    // Safe conversions
    const adjMinus = parseFloat(invItem.adjustmentMinues || 0);
    const adjPlus = parseFloat(invItem.adjustmentPlus || 0);
    const adpDeduction = parseFloat(invItem.adpDeduction || 0);

    // Calculate final adjustment (sum of all)
    const adjustment = -adjMinus + adjPlus - adpDeduction;

    return <span>{adjustment.toFixed(2)}</span>;
  };


  const getFinalAmout = (item, rate) => {
    // Base amount
    let fAmt = getTotalHours(item?.workingHrs) * rate;

    // Find invoice adjustments
    const invItem = timeLogInvoices.find(x => x.timeLogId === item.id);

    if (!invItem) {
      return fAmt.toFixed(2);
    }

    // Safe values (convert undefined/null/"" to 0)
    const adjMinus = parseFloat(invItem?.adjustmentMinues || 0);
    const adjPlus = parseFloat(invItem?.adjustmentPlus || 0);
    const adpDeduction = parseFloat(invItem?.adpDeduction || 0);

    // Apply adjustments
    fAmt = fAmt - adjMinus + adjPlus - adpDeduction;

    return fAmt.toFixed(2);
  };

  return (
    <Modal show={genShowHide} size="xl">
      <Modal.Header closeButton onHide={() => handleGenShowHide("")}>
        <Modal.Title>Generate Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body className="border pl-6 pr-6">
        <div className="col-md-12" style={{ maxHeight: "700px", overflow: "auto" }}>
          {logoPicObj?.imagePreviewUrl ? <img
            id="Img1"
            alt="profileLogo"
            src={logoPicObj.imagePreviewUrl}
            style={{ height: "150px", marginBottom: "5px", borderRadius: "10px" }}
          /> : <img
            id="Img1"
            alt="profileLogo"
            src={`${process.env.REACT_APP_API_BASEURL}/CompanyLogo/${logoData}`}
            //src={`${process.env.REACT_APP_API_BASEURL}/CompanyLogo/b06a060f-3da5-4543-b41c-ee88bf25fc58_hello.jpg`}
            style={{ height: "150px", marginBottom: "5px", borderRadius: "10px" }}
          />}

          <div id="printBodyRef" ref={printBodyRef}>
            <table
              width="100%"
              cellPadding="5"
              cellSpacing="0"
              border="0"
              style={{ borderBottom: "1px solid #ccc", marginBottom: "25px" }}
            >
              <tr>
                <td align="left" colSpan={2}>
                  <p >
                    <span hidden="true"></span>
                  </p>
                </td>
                <td colSpan={2} align="right">
                  <p
                    style={{
                      fontSize: "30px",
                      fontWeight: "bold",
                      padding: "2px",
                      color: "#4646EE"
                    }}
                  >
                    INVOICE
                  </p>
                </td>
              </tr>
              <tr style={{ fontSize: "14px", fontWeight: "bold", padding: "0px" }}>
                <td width="50%"></td>
                <td width="20%" valign="top">Invoice Number</td>
                <td width="1%">:</td>
                <td style={{ textAlign: "right", whiteSpace: "warp" }}>
                  {invNumber && invNumber}
                </td>
              </tr>
              <tr style={{ fontSize: "14px", fontWeight: "bold", padding: "0px" }}>
                <td></td>
                <td>Invoice Date</td>
                <td>:</td>
                <td align="right">{new Date().toLocaleDateString()}</td>
              </tr>
              <tr style={{ fontSize: "14px", fontWeight: "bold", padding: "0px" }}>
                <td></td>
                <td>Payment Term</td>
                <td>:</td>
                <td align="right"> Net 30 Days</td>
              </tr>
              <tr>
                <td colSpan={4} style={{ paddingTop: "10px" }}>
                  <p>&nbsp;&nbsp;</p>
                </td>
              </tr>
            </table>
            <table
              cellPadding="5"
              cellSpacing="0"
              width="100%"
              border="0"
              style={{ marginBottom: "25px" }}
            >
              <tbody>
                <tr>
                  <td
                    style={{ fontSize: "17px", fontWeight: "bold", backgroundColor: "rgb(236 236 244)" }}
                    width="51%"
                  >
                    {userDetails && getFieldData(
                      userDetails.performerData,
                      ddName,
                      "Company_Name"
                    )}
                  </td>
                  <td
                    style={{
                      fontSize: "17px",
                      fontWeight: "bold",
                      backgroundColor: "rgb(214 214 241)",
                      border: "1px solid #ccc",
                    }}
                  >
                    Bill To/Ship To
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ccc", fontSize: "14px", marginBottom: "2px", backgroundColor: "rgb(214 214 241)" }}>
                    {wfTask && (
                      <React.Fragment>
                        <p style={{
                          paddingTop: "2px",
                          paddingBottom: "2px"
                        }}>
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Company_Address_Line1"
                          )}
                        </p>
                        <p style={{
                          paddingTop: "2px",
                          paddingBottom: "2px"
                        }}>
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Company_City"
                          )}
                          ,{" "}
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Company_State"
                          )}{" "}
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Company_Zip_Code"
                          )}
                        </p>

                        <p style={{
                          paddingTop: "2px",
                          paddingBottom: "2px"
                        }}>
                          Federal ID :{" "}
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Federal_ID"
                          )}
                        </p>
                        <p style={{
                          paddingTop: "2px",
                          paddingBottom: "2px"
                        }}>
                          Phone :{" "}
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Company_Phone_Code"
                          )}{" "}
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Company_Phone"
                          )}
                        </p>
                        <p style={{
                          paddingTop: "2px",
                          paddingBottom: "2px"
                        }}>
                          Email ID :{" "}
                          {getFieldData(
                            wfTask.stateData,
                            ddName,
                            "Company_Email"
                          )}
                        </p>
                        <p style={{
                          paddingTop: "2px",
                          paddingBottom: "2px"
                        }}>ID : {partnerId}</p>
                      </React.Fragment>
                    )}
                  </td>
                  <td style={{ border: "1px solid #ccc", fontSize: "14px", marginBottom: "2px", backgroundColor: "rgb(236 236 244)" }} valign="top">
                    <p style={{
                      paddingTop: "2px",
                      paddingBottom: "2px"
                    }}>
                      International Projects Consultancy Services (IPCS) Inc.
                    </p>

                    <p style={{
                      paddingTop: "2px",
                      paddingBottom: "2px"
                    }}>600 Highway 169 South</p>
                    <p style={{
                      paddingTop: "2px",
                      paddingBottom: "2px"
                    }}>METROPOINT, Suite 1595</p>
                    <p style={{
                      paddingTop: "2px",
                      paddingBottom: "2px"
                    }}>Minneapolis, MN 55426</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              cellPadding="2"
              cellSpacing="0"
              width="100%"
              style={{
                border: "1px solid #ccc",
                borderBottom: "0px",
                borderLeft: "0px",
                marginBottom: "45px",
              }}
            >
              <thead style={{ backgroundColor: "#f0f0f0", fontSize: "12px" }}>
                <tr>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Candidate Name
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Period
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Hours
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Rate/hr ($)
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Invoice Amount ($)
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Adjustment ($)
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Final Amount ($)
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "12px" }}>
                <tr>
                  <td
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {candidateObj && candidateObj.performername} {candidateObj && candidateObj.lastName}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {selectedObj && getMonthlyPeriod(selectedObj)}
                  </td>
                  <td
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {selectedObj && formatTotalHours(selectedObj.workingHrs)}
                  </td>
                  <td
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {(rate).toFixed(2) || 0}
                  </td>
                  <td
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {selectedObj && (getTotalHours(selectedObj.workingHrs) * rate).toFixed(2)}
                  </td>
                  <td
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {selectedObj && getAdjustmentAmout(selectedObj)}
                  </td>
                  <td
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {selectedObj && getFinalAmout(selectedObj, rate)}
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={6}
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    SubTotal
                  </td>
                  <td
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {selectedObj && getFinalAmout(selectedObj, rate)}
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={6}
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    Total
                  </td>
                  <td
                    align="right"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      paddingTop: "3px",
                      paddingBottom: "3px"
                    }}
                  >
                    {selectedObj && getFinalAmout(selectedObj, rate)}
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              cellPadding="2"
              cellSpacing="0"
              width="100%"
              style={{
                border: "1px solid #ccc",
                borderBottom: "0px",
                borderLeft: "0px",
                marginBottom: "85px",
              }}
            >
              <tbody style={{ fontSize: "12px" }}>
                <tr>
                  <td
                    width="15%"
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                      fontWeight: "bold",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    Service
                  </td>
                  <td
                    style={{
                      border: "1px solid #ccc",
                      borderTop: "0px",
                      borderRight: "0px",
                    }}
                  >
                    As per IT consulting services agreement and purchase order
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <p style={{ fontWeight: "bold", paddingBottom: "5px" }}>
              Signature
            </p> */}
            <p style={{
              fontStyle: "italic", fontWeight: "bold",
              fontSize: "14px", marginBottom: "3px", marginTop: "13px"
            }}>{esignName}</p>
            <p style={{ fontSize: "14px", marginBottom: "3px" }}>{new Date().toUTCString()}</p>
            <p style={{ fontSize: "14px", marginBottom: "3px" }}>IP Address : {ipAddress}</p>
            <p style={{ fontSize: "14px", marginBottom: "3px" }}>
              Name : {userDetails?.performername} {userDetails?.lastName}
            </p>
          </div>
          <div className="row mt-3">
            {/* <div className="col-md-12">
              <label htmlFor="esignName" className="form-control-label">Sign Digitally</label>
              <textarea cols="2" rows={2}
                id="esignName"
                name="esignName"
                className="form-control"
                value={esignName}
                placeholder="Sign Digitally"
                onChange={({ currentTarget }) => setEsignName(currentTarget.value)}
              ></textarea>
            </div> */}
            <div className="col-md-6">
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>

        <button className="btn btn-sm btn-outline-dark"
          disabled={saveBtnProccess}
          onClick={handleSaveGenerate}>
          {saveBtnProccess ? <i className="fa fa-spinner fa-spin"></i> :
            <i className="fa fa-paper-plane" aria-hidden="true"></i>} Generate & Send
        </button>
        <button className="btn btn-sm btn-outline-default"
          disabled={pdfBtnProccess}
          onClick={doSubmit}>
          {pdfBtnProccess ? <i className="fa fa-spinner fa-spin"></i> :
            <i className="fa fa-print" aria-hidden="true"></i>} Print PDF
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default GenerateInvoice;
